.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  /* biome-ignore lint/complexity/noImportantStyles: mantine */
  background-color: var(--mantine-color-disabled) !important;
  color: var(--mantine-color-disabled-color);
}
